import { Box, Drawer, ListItem, ListItemButton, ListItemText, Paper, Stack, Toolbar } from '@mui/material';
import React from 'react';
import { useAppSelector } from '../../../app/hooks';
import { selectCategories } from '../../admin/questions/CategoriesView/categorySlice';
import { useParams } from 'react-router-dom';
import { CategoryDrawerProps } from './types';

const CategoryDrawer = ({ navigate }: CategoryDrawerProps) => {
  const categoryState = useAppSelector(selectCategories);
  const { categoryId } = useParams();

  return (
    <Box display="flex">
      <Drawer
        variant="permanent"
        sx={{
          width: '25vW',
          flexShrink: 0,
          ['& .MuiDrawer-paper']: { width: '25vW', boxSizing: 'border-box' }
        }}
        PaperProps={{ sx: { backgroundColor: 'transparent' } }}
      >
        <Toolbar />
        <Box sx={{ overflow: 'auto' }}>
          <Stack spacing={1} marginY={1}>
            {categoryState.categories.map((category) => (
              <Paper key={category.id} elevation={4}>
                <ListItem
                  sx={{
                    padding: 0
                  }}
                >
                  <ListItemButton
                    sx={{
                      borderRadius: 1,
                      border: 4,
                      borderColor: String(category.id) === categoryId ? 'primary.main' : 'transparent'
                    }}
                    onClick={() => navigate(`/test/${category.id}/0`)}
                  >
                    <ListItemText primary={category.name} secondary={category.description} />
                  </ListItemButton>
                </ListItem>
              </Paper>
            ))}
          </Stack>
        </Box>
      </Drawer>
    </Box>
  );
};

export default CategoryDrawer;
